<template>
    <div class="hotel-services" :class="{'hotel-services--empty': !offer.services.length && !icons.length}">
        <template v-if="offer.services.length && icons.length">
            <v-icon v-for="(icon, index) in icons" :key="index" color="success" class="me-3" :title="$t(icon.title)">
                {{ icon.ico }}
            </v-icon>
        </template>
        <div v-else class="hotel-services__empty">
            <span>&nbsp;</span>
        </div>
    </div>
</template>

<script lang="ts">
    import {Vue, Component, Prop} from 'vue-facing-decorator'
    import {popularServicesMapping} from '@/utils/hotels/hotel-transformers'

    //TODO Make mapping on api response transform for size optimization

    @Component
    export class HotelServices extends Vue {
        @Prop({required: true}) offer

        get icons() {
            return Object.values(
                this.offer.services.reduce((icons, groupName) => {
                    const serviceWithCode = this.offer.otaCodeServices.find(e => e.name === groupName)
                    if (serviceWithCode && popularServicesMapping[serviceWithCode.otaCode]) {
                        icons[serviceWithCode.otaCode] = popularServicesMapping[serviceWithCode.otaCode]
                    }
                    return icons
                }, {})
            )
        }
    }

    export default HotelServices
</script>
